import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { OAuthService } from 'angular-oauth2-oidc';
import { LoggedUser } from '../../common/logged-user.service';
import { TenantsService } from '../../services/tenants.service';
import { TimezoneService } from '../../services/timezone.service';
import * as moment from 'moment';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopBarComponent implements OnInit {

  @Output() openCloseMenu = new EventEmitter<boolean>();

  languages: any;
  selectedLanguage: any;
  userData: any;
  timezones: any[];

  private isMenuOpen = true;
  selectedTimezone: any;
  preferences: any;

  constructor(private translocoService: TranslocoService,
              private oauthService: OAuthService,
              private tenantsService: TenantsService,
              private timezoneService: TimezoneService,
              private loggedUser: LoggedUser) {
    loggedUser.userObservable.subscribe( user => {
      this.userData = user;
    });
    loggedUser.userPreferences.subscribe(preferences => {
      this.preferences = preferences;
    });
  }

  ngOnInit(): void {
    this.languages = [
      {name: 'Español', code: 'es', langCode: 'es'},
      {name: 'English', code: 'gb', langCode: 'en'},
    ];
    this.timezones = this.timezoneService.getAllTimezones();
    this.selectedTimezone = this.timezoneService.getCurrentTimezone();
    this.selectedLanguage = this.languages[0];
  }

  logout(): void {
    this.oauthService.logOut();
  }

  public switchMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.openCloseMenu.emit(this.isMenuOpen);
  }

  changeLanguage(event: any): void {
    const langCode = event.value.langCode;
    this.translocoService.setActiveLang(langCode);
  }

  timezoneChanged(event: any): void {
    this.timezoneService.setTimezone(event.value);
  }

  guessTimezone(): void {
    this.timezoneService.guessTimezone();
    this.selectedTimezone = this.timezoneService.getCurrentTimezone();
  }

}
